import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useOrganizationByGroupIdLazyQuery, useUserGroupByIdBasicLazyQuery, } from "../../graphql/__generated__";
export default function useGroupFromParamOptional() {
    const params = useParams();
    const { groupId } = params;
    const [fetchUserGroupByIdBasic, { loading: userGroupLoading, data: userGroupData, error: userGroupError, called: userGroupCalled, },] = useUserGroupByIdBasicLazyQuery();
    const [fetchOrganizationByGroupId, { loading: organizationLoading, data: organizationData, error: organizationError, called: organizationCalled, },] = useOrganizationByGroupIdLazyQuery();
    useEffect(() => {
        if (groupId) {
            fetchUserGroupByIdBasic({
                variables: { id: groupId },
            });
            fetchOrganizationByGroupId({
                variables: { groupId },
            });
        }
    }, [groupId, fetchOrganizationByGroupId, fetchUserGroupByIdBasic]);
    const organizationId = useMemo(() => {
        var _a;
        if (organizationLoading || organizationError) {
            return null;
        }
        return (((_a = organizationData === null || organizationData === void 0 ? void 0 : organizationData.flattened_user_group_users[0]) === null || _a === void 0 ? void 0 : _a.organization_id) ||
            groupId);
    }, [organizationData, organizationLoading, organizationError, groupId]);
    const loading = useMemo(() => userGroupLoading || organizationLoading, [userGroupLoading, organizationLoading]);
    const called = useMemo(() => userGroupCalled && organizationCalled, [userGroupCalled, organizationCalled]);
    const error = useMemo(() => {
        if (userGroupError)
            return userGroupError;
        if (organizationError)
            return organizationError;
        return null;
    }, [userGroupError, organizationError]);
    const groupData = useMemo(() => {
        if (userGroupData === null || userGroupData === void 0 ? void 0 : userGroupData.user_groups_by_pk) {
            const { name: groupName, display_name: groupDisplayName } = userGroupData.user_groups_by_pk;
            return {
                groupName,
                groupDisplayName,
            };
        }
        return {
            groupName: "",
            groupDisplayName: "",
        };
    }, [userGroupData]);
    if (!groupId) {
        return {
            loading: false,
            error: null,
            data: {},
        };
    }
    return {
        loading: called ? loading : true,
        error,
        data: {
            groupId,
            ...groupData,
            organizationId: organizationId || "",
        },
    };
}
//# sourceMappingURL=index.js.map